var React = require('react');

function Man (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-5389.238 -3455.897)"},[React.createElement("path",{"d":"M5400.528,3540.554h13.3a4.021,4.021,0,0,0,4.009-4.009v-21.983h2.271a4.02,4.02,0,0,0,4.009-4.009v-24.791a4.02,4.02,0,0,0-4.009-4.009h-25.858a4.021,4.021,0,0,0-4.009,4.009v24.791a4.022,4.022,0,0,0,4.009,4.009h2.272v21.983A3.978,3.978,0,0,0,5400.528,3540.554Z","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"2","key":0}),React.createElement("circle",{"cx":"10.491","cy":"10.491","r":"10.491","transform":"translate(5396.652 3456.897)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"2","key":1})]));
}

Man.defaultProps = {"width":"36","height":"86","viewBox":"0 0 36 86"};

module.exports = Man;

Man.default = Man;
